import React, {useEffect, useState} from 'react';
import {Box, Grid, Typography} from '@mui/material';
import '../../styles/DashboardPage.css';
import {useNavigate} from "react-router-dom";
import * as DataProvider from "../../logic/DataProvider";
import ClockDashboardItem from "./ClockDashboardItem";
import {
    Black,
    MyDashboardItemGray,
    MyDashboardItemGrayClickable, MyDashboardItemWhite,
    MyDashboardTypography,
    Orange, StyledButtonWhite
} from "../../styles/MyStyles";
import {GetEnumValueName} from "../../logic/EnumHelper";
import {GetLookupValueName} from "../../logic/LookupHelper";
import dayjs from "dayjs";
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import ChecklistIcon from "@mui/icons-material/Checklist";
import TuneIcon from "@mui/icons-material/Tune";
import ListAltIcon from "@mui/icons-material/ListAlt";
import {FormatMoney} from "../../logic/MoneyHelper";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import FastForwardIcon from '@mui/icons-material/FastForward';
import * as MyStyles from "../../styles/MyStyles";

const ClientDashboard = () => {
    const navigate = useNavigate();
    const [dashboard, setDashboard] = useState();

    useEffect(() => {
        const fetchDashboard = async () => {
            try {
                let bundle = DataProvider.GetClientBundle();
                if (bundle.dashboard) {

                    if (bundle.dashboard.orders) {
                        bundle.dashboard.orders.sort((a, b) => {
                            const dateA = new Date(a.createdDate);
                            const dateB = new Date(b.createdDate);
                            return dateB - dateA;
                        });
                    }

                    if (bundle.dashboard.trades) {
                        bundle.dashboard.trades.sort((a, b) => {
                            const dateA = new Date(a.date);
                            const dateB = new Date(b.date);
                            return dateB - dateA;
                        });
                    }

                    setDashboard(bundle.dashboard);
                }

            } catch (error) {
                console.log('An error occurred:', error);
            }
        };

        if (!dashboard)
            fetchDashboard();
    }, []);

    const activeOrdersSectionClick = () => {
        navigate(`/orders`);
    };
    const lastTradesSectionClick = () => {
        navigate(`/trades`);
    };

    const newOrderClick = () => {
        navigate(`/orders/request`);
    };

    const newTicketClick = () => {
        navigate(`/tickets/new`);
    };
    const newLimitClick = () => {
        navigate(`/limits/request`);
    };

    const newDepositClick = () => {
        navigate(`/transfers/request/deposit`);
    };

    const orderDashboardItemClick = (e, order) => {
        e.stopPropagation();
        navigate(`/orders`);
    };
    const tradeDashboardItemClick = (e, trade) => {
        e.stopPropagation();
        navigate(`/trades`);
    };

    const getTradeSides = (trade) => {
        let order = dashboard.orders.find(e => e.id === trade.orderId);
        return `${GetLookupValueName('asset', order?.sellAssetId)} -> ${GetLookupValueName('asset', order?.buyAssetId)}`;
    };

    const getPrice = (trade) => {
        let order = dashboard.orders.find(e => e.id === trade.orderId);
        let sellAsset = GetLookupValueName('asset', order.sellAssetId);
        let buyAsset = GetLookupValueName('asset', order.buyAssetId);
        let assetSub = trade.action === 0
            ? `${sellAsset}/${buyAsset}`
            : `${buyAsset}/${sellAsset}`;

        return `${trade.price} ${assetSub}`;
    };

    return (
        <Box sx={{ flexGrow: 1, marginLeft: '50px', marginRight: '50px' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} style={{ marginTop: '20px' }}>
                    <ClockDashboardItem/>
                </Grid>
                <Grid item xs={3}>
                    <MyDashboardItemGray style={{minHeight: '100px'}}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <b>Actual operation limits</b>
                            <RunningWithErrorsIcon />
                        </div>
                        {dashboard && dashboard.actualLimits?.map((limit) => (
                            <MyDashboardTypography key={limit.id} style={{ margin: '5px' }}>
                                {`${GetLookupValueName('asset', limit.assetId)} : ${limit.reminderVolume}`}
                            </MyDashboardTypography>
                        ))}
                        {dashboard && (!dashboard.actualLimits || dashboard.actualLimits?.length === 0) && (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <StyledButtonWhite style={{ flex: 1, marginTop: '5px', height: '70px', fontWeight: 'bold' }}
                                                   onClick={newLimitClick}>
                                    Request access to operations
                                </StyledButtonWhite>
                            </div>
                        )}
                    </MyDashboardItemGray>
                </Grid>
                <Grid item xs={3}>
                    <MyDashboardItemGray style={{minHeight: '100px'}}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <b>Total Deals</b>
                            <ChecklistIcon />
                        </div>
                        <MyDashboardTypography>Monthly: {dashboard?.totalDeals.monthly}</MyDashboardTypography>
                        <MyDashboardTypography>Yearly: {dashboard?.totalDeals.yearly }</MyDashboardTypography>
                    </MyDashboardItemGray>
                </Grid>
                <Grid item xs={6}>
                    <MyDashboardItemGray style={{minHeight: '100px'}}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <b>Easy access</b>
                            <FastForwardIcon />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                            <StyledButtonWhite style={{ flex: 1, marginRight: '5px', marginTop: '5px', height: '70px', fontWeight: 'bold' }}
                                onClick={newOrderClick}>
                                New order
                            </StyledButtonWhite>
                            <StyledButtonWhite style={{ flex: 1, marginLeft: '5px', marginTop: '5px', height: '70px', fontWeight: 'bold' }}
                                onClick={newTicketClick}>
                                New ticket
                            </StyledButtonWhite>
                        </div>
                    </MyDashboardItemGray>
                </Grid>
                <Grid item xs={3}>
                    <MyDashboardItemGrayClickable onClick={activeOrdersSectionClick}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                            <b>ORDERS</b>
                            <TuneIcon />
                        </div>
                        {dashboard && dashboard.orders?.map((order) => (
                            <MyDashboardItemWhite key={order.id} onClick={(e) => orderDashboardItemClick(e, order)}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography style={{ color: Orange, fontWeight: 'bold' }}>
                                        {GetEnumValueName('orderStatus', order.status)}
                                    </Typography>
                                    <Typography>
                                        {GetEnumValueName('orderType', order.type)}
                                    </Typography>
                                </div>
                                <Typography style={{ marginTop: '10px', fontWeight: 'bold' }}>
                                    {GetLookupValueName('asset', order.sellAssetId)} -> {GetLookupValueName('asset', order.buyAssetId)}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography>
                                        {order.type === 0
                                            ? order.action === 1
                                                ? `${order.cryptoAmountRequested} -> ${order.requestedPrice * order.cryptoAmountRequested}`
                                                : `${order.requestedPrice * order.cryptoAmountRequested} -> ${order.cryptoAmountRequested}`
                                            : order.cryptoAmountRequested
                                        }
                                    </Typography>
                                    <Typography>
                                        {dayjs(order.createdDate).format(MyStyles.DateFormat)}
                                    </Typography>
                                </div>
                            </MyDashboardItemWhite>
                        ))}
                        {dashboard && (!dashboard.orders || dashboard.orders.length === 0) && (
                            <Typography style={{ marginTop: '10px', height: '70px' }}>
                                You have no orders.
                            </Typography>
                        )}
                    </MyDashboardItemGrayClickable>
                </Grid>
                <Grid item xs={3}>
                    <MyDashboardItemGrayClickable onClick={lastTradesSectionClick}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                            <b>LAST TRADES</b>
                            <ListAltIcon />
                        </div>
                        {dashboard && dashboard.trades?.map((trade) => (
                            <MyDashboardItemWhite key={trade.id} onClick={(e) => tradeDashboardItemClick(e, trade)}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography style={{ color: Orange, fontWeight: 'bold' }}>
                                        {GetEnumValueName('orderAction', trade.action)}
                                    </Typography>
                                    <Typography>
                                        {getPrice(trade)}
                                    </Typography>
                                </div>
                                <Typography style={{ marginTop: '10px', fontWeight: 'bold' }}>
                                    {getTradeSides(trade)}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography>
                                        {trade.action === 1 ? `${trade.cryptoAmount} -> ${trade.price * trade.cryptoAmount}` : `${trade.price * trade.cryptoAmount} -> ${trade.cryptoAmount}`}
                                    </Typography>
                                    <Typography>
                                        {dayjs(trade.date).format(MyStyles.DateFormat)}
                                    </Typography>
                                </div>
                            </MyDashboardItemWhite>
                        ))}
                        {dashboard && (!dashboard.trades || dashboard.trades.length === 0) && (
                            <Typography style={{ marginTop: '10px', height: '70px' }}>
                                You have no trades.
                            </Typography>
                        )}
                    </MyDashboardItemGrayClickable>
                </Grid>
                <Grid item xs={6}>
                    <MyDashboardItemGray>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                            <b>Balance</b>
                            <AccountBalanceWalletIcon />
                        </div>
                        {dashboard && dashboard.balance?.items.map((balanceItem) => (
                            <MyDashboardItemWhite key={balanceItem.asset}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography style={{ color: Orange, fontWeight: 'bold' }}>
                                        {balanceItem.asset}
                                    </Typography>
                                    <Typography style={{ color: Black,  fontWeight: 'bold' }}>
                                        {FormatMoney(balanceItem.balanceAtTheEnd)}
                                    </Typography>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography>
                                        Available for Withdrawal
                                    </Typography>
                                    <Typography>
                                        {FormatMoney(balanceItem.availableForWithdrawal)}
                                    </Typography>
                                </div>
                            </MyDashboardItemWhite>
                        ))}
                        {dashboard && (!dashboard.balance || !dashboard.balance.items || dashboard.balance.items.length === 0) && (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <StyledButtonWhite style={{ flex: 1, height: '70px', fontWeight: 'bold' }}
                                                   onClick={newDepositClick}>
                                    Deposit
                                </StyledButtonWhite>
                            </div>
                        )}
                    </MyDashboardItemGray>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ClientDashboard;